import React, { useEffect, useState } from 'react';
import {
    postRebatesApi,
    updateRebatesApi,
    deleteRebatesApi,
    postAprobarRebatesApi
} from '../../../../api/axios'
import { formatCurrencyToNumber } from '../../../../helper/publicacionHelper';
import { formatoDecimal } from '../../../../utilities/formatoNumeros';
import { idEstadoRebate } from '../../../../helper/rebateHelper';
import MiniSpinner from "../../../General/MiniSpinner";
import "../../../Rebates/Styles/Rebates.css";
import { toast } from 'react-toastify';

function Rebate({ publicacion, userType, rebate, idUsuario, updateDataRebate }) {
    const DEFAULT_REBATE = {
        aCargoMegatone: 0,
        aCargoSeller: 0,
        fechaInicio: "",
        fechaVencimiento: "",
        idAdminAprueba: 0,
        idCategoryGeneraRebate: 0,
        idEstadoRebate: 0,
        idPublicacion: 0,
        idSellerAprueba: 0,
        porcentajeMegatone: 0,
        porcentajeSeller: 0,
        porcentajeTotalDescuento: 0,
        precioFinal: 0,
        precioInicial: 0,
        unidades: 0,
    };
    const [isLoading, setIsLoading] = useState(false);
    const [tieneRebate, setTieneRebate] = useState(publicacion.tieneRebate);
    const [rebateState, setRebate] = useState(DEFAULT_REBATE);

    useEffect(() => {
        if (publicacion.tieneRebate) {
            setRebate(prevState => ({
                ...prevState,
                idPublicacion: rebate.idPublicacion,
                precioInicial: parseFloat(rebate.precioInicial),
                precioFinal: rebate.precioFinal,
                aCargoMegatone: parseFloat(rebate.aCargoMegatone),
                aCargoSeller: parseFloat(rebate.aCargoSeller),
                idCategoryGeneraRebate: rebate.idCategoryGeneraRebate,
                fechaInicio: rebate.fechaInicio ? rebate.fechaInicio.slice(0, 10) : "",
                fechaVencimiento: rebate.fechaVencimiento ? rebate.fechaVencimiento.slice(0, 10) : "",
                unidades: rebate.unidades,
                idAdminAprueba: rebate.idAdminAprueba,
                idSellerAprueba: rebate.idSellerAprueba,
                porcentajeTotalDescuento: rebate.porcentajeTotalDescuento,
                porcentajeSeller: rebate.porcentajeSeller,
                porcentajeMegatone: rebate.porcentajeMegatone,
                idEstadoRebate: rebate.idEstadoRebate
            }));
        } else {
            setRebate(prevState => ({
                ...prevState,
                precioFinal:
                    publicacion.precioPromocional == "0,00" || isNaN(parseFloat(publicacion.precioPromocional))
                        ? publicacion.precioLista
                        : publicacion.precioPromocional
            }));
        }
    }, []);

    const myChangeHandler = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        setRebate(prevState => ({ ...prevState, [name]: value }));
    };

    const myChangeAmount = async (e) => {
        e.preventDefault();

        const { name, value } = e.target;
        let valueParsed = value ? parseFloat(value) : 0;
        e.target.value = valueParsed;
        await myChangeHandler(e);

        let precioFinal, porcentajeTotal;

        let inicial =
            publicacion.precioPromocional == "0,00" || isNaN(parseFloat(publicacion.precioPromocional))
                ? publicacion.precioLista
                : publicacion.precioPromocional
            ;

        if (name === "aCargoSeller") {
            let sale = parseFloat(rebateState.aCargoMegatone) + valueParsed;
            precioFinal = formatCurrencyToNumber(inicial) - parseFloat(sale);
            let porcentaje = (valueParsed * 100) / formatCurrencyToNumber(inicial);
            porcentajeTotal = parseFloat(porcentaje) + parseFloat(rebateState.porcentajeMegatone);
            setRebate(prevState => ({ ...prevState, porcentajeSeller: porcentaje.toFixed(2) }));
        }

        if (name === "aCargoMegatone") {
            let sale = parseFloat(rebateState.aCargoSeller) + valueParsed;
            precioFinal = formatCurrencyToNumber(inicial) - parseFloat(sale);
            let porcentaje = (valueParsed * 100) / formatCurrencyToNumber(inicial);
            porcentajeTotal = parseFloat(porcentaje) + parseFloat(rebateState.porcentajeSeller);
            setRebate(prevState => ({ ...prevState, porcentajeMegatone: porcentaje.toFixed(2) }));
        }

        setRebate(prevState => ({
            ...prevState,
            precioFinal: precioFinal,
            porcentajeTotalDescuento: porcentajeTotal.toFixed(2)
        }));
    }

    const onDelete = (event) => {
        event.preventDefault();
        const req = deleteRebatesApi(rebate.idRebate);
        req.then(response => {
            toast.success("Rebate eliminado");
            setTieneRebate(false);
            setRebate(prevState => ({
                ...DEFAULT_REBATE,
                precioFinal: publicacion.tieneRebate ? 0 : publicacion.precioLista,
                porcentajeMegatone: prevState.porcentajeMegatone,
                porcentajeSeller: prevState.porcentajeSeller,
                porcentajeTotalDescuento: prevState.porcentajeTotalDescuento
            }));
            return;
        }).catch(err => {
            (err.response.data.errores) ?
                err.response.data.errores.forEach(error => toast.error(error)) :
                toast.error("No pudo eliminarse");
        })
    }

    const onChangeState = (event) => {
        event.preventDefault();
        setIsLoading(true);

        let request = {
            idRebate: rebate.idRebate,
            idUsuario: idUsuario
        };

        switch (event.target.name) {
            case "aprove":
                request.idEstado = idEstadoRebate.aprobado;
                break;
            case "sellerAprove":
                request.idEstado = idEstadoRebate.aprobadoPorSeller;
                break;
            case "decline":
                request.idEstado = idEstadoRebate.rechazado;
                break;
        }

        const req = postAprobarRebatesApi(request);
        req.then(response => {
            if (request.idEstado === idEstadoRebate.aprobado || request.idEstado === idEstadoRebate.aprobadoPorSeller) {
                toast.success("Rebate aprobado");
                setRebate(prevState => ({ ...prevState, idEstadoRebate: request.idEstado }));
            } else {
                toast.success("Rebate desaprobado");
                setTieneRebate(false);
                setRebate(prevState => ({
                    ...DEFAULT_REBATE,
                    precioFinal: publicacion.tieneRebate ? 0 : publicacion.precioLista,
                    porcentajeMegatone: prevState.porcentajeMegatone,
                    porcentajeSeller: prevState.porcentajeSeller,
                    porcentajeTotalDescuento: prevState.porcentajeTotalDescuento
                }));
            }
            return;
        }).catch(err => {
            (err.response.data.errores) ?
                err.response.data.errores.forEach(error => toast.warn(error)) :
                toast.error("No pudo modificarse el estado");
        }).finally(() => {
            setIsLoading(false);
        })
    }

    const onSubmit = (event) => {
        event.preventDefault();

        const { precioFinal, aCargoMegatone, aCargoSeller, unidades, fechaInicio, fechaVencimiento } = rebateState;
        if (formatCurrencyToNumber(precioFinal) < 0) {
            toast.error("El precio final no puede ser negativo");
            return;
        }
        if (formatCurrencyToNumber(aCargoMegatone) < 0) {
            toast.error("El precio a cargo de megatone no puede ser negativo");
            return;
        }
        if (formatCurrencyToNumber(aCargoSeller) < 0) {
            toast.error("El precio a cargo del seller no puede ser negativo");
            return;
        }
        if (formatCurrencyToNumber(unidades) < 0) {
            toast.error("La cantidad de unidades no puede ser negativa");
            return;
        }

        let rebateRequest = {
            idPublicacion: publicacion.idPublicacion,
            precioFinal: formatCurrencyToNumber(precioFinal),
            aCargoMegatone: formatCurrencyToNumber(aCargoMegatone),
            aCargoSeller: formatCurrencyToNumber(aCargoSeller),
            idCategoryGeneraRebate: idUsuario,
            fechaInicio: fechaInicio,
            fechaVencimiento: fechaVencimiento,
            unidades: parseInt(unidades),
        };

        rebateRequest.unidades = isNaN(rebateRequest.unidades) ? 0 : rebateRequest.unidades;

        if (event.target.name === "send") {
            rebateRequest.precioInicial = formatCurrencyToNumber(publicacion.precioPromocional);

            if (rebateRequest.precioInicial == null || rebateRequest.precioInicial == 0) {
                rebateRequest.precioInicial = formatCurrencyToNumber(publicacion.precioLista);
            }
            const req = postRebatesApi(rebateRequest);
            req.then(response => {
                toast.success("Rebate enviado");
                updateDataRebate(publicacion.idPublicacion);
                let rebate = updateDataRebate(publicacion.idPublicacion);
                setRebate(prevState => ({ ...prevState, idEstadoRebate: 1 }));
                setTieneRebate(true);
                return;
            }).catch(err => {
                (err.response.data.errores)
                    ? err.response.data.errores.forEach(error => toast.error(error))
                    : toast.error("No pudo crearse");
            })
        } else {
            rebateRequest.idRebate = rebate.idRebate;
            const req = updateRebatesApi(rebateRequest);
            req.then(response => {
                toast.success("Rebate modificado");
                updateDataRebate(publicacion.idPublicacion);
                let rebate = updateDataRebate(publicacion.idPublicacion);
                setRebate(prevState => ({ ...prevState, rebate }));
                return;
            }).catch(err => {
                (err.response.data.errores)
                    ? err.response.data.errores.forEach(error => toast.error(error))
                    : toast.error("No pudo modificarse");
            })
        }
    }

    let precioFinalFormatted = formatoDecimal(rebateState.precioFinal);

    return (
        <div
            className={`tab-pane p-20 active card-rebate 
                ${userType.isAdminMod && rebate.idAdminAprueba === 0
                    ? "top-color-rojo"
                    : publicacion.tieneRebate
                        ? "top-color-verde"
                        : "card w-auto"
                }`
            }
            role="tabpanel"
            hidden={
                (userType.isSellerAdmin || userType.isSeller) && !tieneRebate ||
                userType.isSellerAdmin &&
                (rebate.idEstadoRebate === idEstadoRebate.aprobadoPorCategory ||
                    rebate.idEstadoRebate === idEstadoRebate.rechazado)
            }
        >
            {publicacion.tieneRebate
                && userType.isAdminMod
                && (rebateState.idEstadoRebate === idEstadoRebate.aprobado
                    || rebateState.idCategoryGeneraRebate !== 0)
                ? <h4 className="text-themecolor color-verde-megatone">Nuevo Rebate Enviado</h4>
                : <h4 className="text-themecolor color-rojo-megatone">Nuevo Rebate</h4>
            }

            <div
                className="container"
                hidden={!userType.isSellerAdmin || !tieneRebate || rebateState.idEstadoRebate === idEstadoRebate.aprobadoPorCategory}
            >
                <p hidden={!rebateState.fechaInicio} className="text-secondary fs-8">
                    {rebateState.fechaInicio} al {rebateState.fechaVencimiento}
                </p>

                <div className="d-flex flex-row align-items-center justify-content-between animated fadeIn">

                    <div className="col-auto">
                        <h2 className="text-themecolor color-rojo-megatone">{rebateState.porcentajeTotalDescuento} % OFF</h2>
                    </div>

                    <div className="col-auto border-start mx-2 ps-1">
                        <div className="d-flex flex-row rebate-text">
                            <h6 className="text-themecolor color-rojo-megatone">{rebateState.porcentajeMegatone} % </h6>
                            <p className="text-secondary fs-6 ms-1">${rebateState.aCargoMegatone} a cargo del MegaMarket</p>
                        </div>
                        <div className="d-flex flex-row">
                            <h6 className="text-themecolor color-rojo-megatone">{rebateState.porcentajeSeller} % </h6>
                            <p className="text-secondary fs-6 ms-1">${rebateState.aCargoSeller} a cargo del Seller</p>
                        </div>
                    </div>

                    <div className="col-auto d-flex flex-column justify-content-end">
                        {rebateState.idEstadoRebate !== idEstadoRebate.aprobadoPorSeller &&
                            <>
                                {isLoading ? <MiniSpinner /> :
                                    <>
                                        <button
                                            name="sellerAprove"
                                            onClick={onChangeState}
                                            className="btn m-r-10 btn-sm waves-light mb-md-3 btn-green"
                                        >
                                            Aceptar Oferta
                                        </button>
                                        <button
                                            name="decline"
                                            onClick={onChangeState}
                                            className="btn m-r-10 btn-sm background-rojo-megatone waves-light mb-md-3"
                                        >
                                            Rechazar Oferta
                                        </button>

                                    </>
                                }
                            </>
                        }
                    </div>
                </div>

                <div className="row justify-content-right animated fadeIn">
                    <div className="col-auto">
                        <div className="d-flex flex-row">
                            <h6 className="text-themecolor color-rojo-megatone">Precio Final:</h6>
                            <p className="text-secondary mx-2">${rebateState.precioFinal}</p>
                        </div>
                    </div>
                    <div className="col-auto">
                        <div className="d-flex flex-row">
                            <h6 className="text-themecolor text-secondary">Unidades:</h6>
                            <p className="text-secondary mx-2">{rebateState.unidades}</p>
                        </div>
                    </div>
                </div>
            </div>

            {!userType.isSellerAdmin &&
                <div className="form-group">

                    <div className="row mb-3 flex align-items-end">
                        <div className="col-auto">
                            <label>Precio Final</label>
                            <input
                                type="text"
                                name="precioFinal"
                                className="form-control"
                                value={precioFinalFormatted}
                                disabled
                            />
                        </div>
                        <div className="col-auto">
                            <h6 className="text-themecolor color-rojo-megatone">
                                {rebateState.porcentajeTotalDescuento > 100 ? "Error" : rebateState.porcentajeTotalDescuento + "%"}
                            </h6>
                        </div>
                    </div>

                    <div className="row mb-3 flex align-items-end">
                        <div className="col-auto">
                            <label>A cargo de Megatone</label>
                            <input
                                type="number"
                                className="form-control"
                                disabled={publicacion.tieneRebate && userType.isSellerAdmin}
                                value={rebateState.aCargoMegatone}
                                onChange={myChangeAmount}
                                name="aCargoMegatone"
                                min="0"
                            />
                        </div>

                        <div className="col-auto">
                            <h6 className="text-themecolor color-rojo-megatone">
                                {rebateState.porcentajeMegatone > 100 ? "Error" : rebateState.porcentajeMegatone + "%"}
                            </h6>
                        </div>

                        <div className="col-auto">
                            <label>A cargo del seller</label>
                            <input
                                type="number"
                                className="form-control"
                                disabled={publicacion.tieneRebate && userType.isSellerAdmin}
                                value={rebateState.aCargoSeller}
                                onChange={myChangeAmount}
                                name="aCargoSeller"
                                min="0"
                            />
                        </div>

                        <div className="col-auto align-center">
                            <h6 className="text-themecolor color-rojo-megatone">
                                {rebateState.porcentajeSeller > 100 ? "Error" : rebateState.porcentajeSeller + "%"}
                            </h6>
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-auto" name="fechaInicio" onMouseEnter={myChangeHandler}>
                            <label className="label-oscura">Fecha Inicio</label>
                            <input
                                type="date"
                                name="fechaInicio"
                                className="form-control"
                                onChange={myChangeHandler}
                                value={rebateState.fechaInicio}
                            />
                        </div>
                        <div className="col-auto" name="fechaVencimiento" onMouseEnter={myChangeHandler}>
                            <label className="label-oscura ml-2">Fecha Vencimiento</label>
                            <input
                                type="date"
                                name="fechaVencimiento"
                                className="form-control"
                                onChange={myChangeHandler}
                                value={rebateState.fechaVencimiento}
                            />
                        </div>
                        <div className="col-auto mb-3">
                            <label>Unidades</label>
                            <input
                                type="number"
                                id="unidades"
                                className="form-control"
                                disabled={tieneRebate && userType.isSellerAdmin}
                                value={rebateState.unidades}
                                onChange={myChangeHandler}
                                name="unidades"
                                min="0"
                            />
                        </div>
                    </div>
                    {(userType.isCategory || userType.isAdminMod) && !tieneRebate ?
                        <div>
                            <button
                                onClick={onSubmit}
                                name="send"
                                className="btn m-r-10 btn-sm background-rojo-megatone waves-light mb-md-5"
                            >
                                Enviar al administrador
                            </button>
                        </div> :

                        (userType.isSellerAdmin && rebateState.idEstadoRebate === idEstadoRebate.aprobado) || (userType.isAdminMod && rebateState.idEstadoRebate === idEstadoRebate.aprobadoPorCategory) ?
                            <div>
                                <button
                                    onClick={onChangeState}
                                    name="aprove"
                                    className="btn m-r-10 btn-sm background-rojo-megatone  waves-light mb-md-5"
                                >
                                    Aprobar
                                </button>
                                <button
                                    onClick={onChangeState}
                                    name="decline"
                                    className="btn m-r-10 btn-sm btn-grey waves-light mb-md-5">
                                    Rechazar
                                </button>
                                <button
                                    onClick={onSubmit}
                                    hidden={(userType.isCategory && rebate.idEstadoRebate === idEstadoRebate.aprobado) || (userType.isAdminMod && rebate.idEstadoRebate === idEstadoRebate.aprobadoPorSeller)}
                                    type="submit"
                                    name="update"
                                    className="btn m-r-10 btn-sm btn-light waves-light mb-md-5"
                                >
                                    Modificar
                                </button>
                            </div>
                            :
                            <div>
                                <button
                                    type="submit"
                                    onClick={onDelete}
                                    className="btn m-r-10 btn-sm btn-grey waves-light mb-md-5"
                                >
                                    Eliminar
                                </button>
                                <button
                                    type="submit"
                                    name="update"
                                    onClick={onSubmit}
                                    disabled={rebateState.idEstadoRebate === idEstadoRebate.aprobadoPorSeller}
                                    className="btn m-r-10 btn-sm btn-light waves-light mb-md-5"
                                >
                                    Modificar
                                </button>
                            </div>
                    }

                    {userType.isCategory ?
                        <p hidden={!tieneRebate} className="text-secondary fs-10">Enviado rebate al administrador</p> :
                        <p hidden={rebateState.idAdminAprueba === 0} className="text-secondary fs-10">Enviado rebate al seller</p>
                    }
                </div>
            }
        </div>
    );
}

export default Rebate;